// Los 6 Momentos de conciencia. Las frases clave van entre [[ ]] (se pintan en dorado).
// Tokens interpolables: {Nombre} {Empresa} {horas} {dias}.
export const MOMENTOS = {
  m1: {
    id: "m1",
    boton: "EMPEZAR",
    parrafos: [
      "{Nombre}, una cosa antes de arrancar.",
      "Imaginate que entrás a la sesión de un psicólogo.",
      "Le contarías todo, ¿no?",
      "Te expresarías sin filtrar, sin resumir, sin fijarte si lo estás diciendo bien. No te guardarías nada. Porque ahí adentro nadie te apura, nadie te corrige, y no hay respuesta correcta.",
      "Bueno: así te lo tenés que imaginar acá.",
      "Contame todo. Cuanto más largo, mejor.",
      "Y no te lo digo para que te sueltes: es literal. Yo solo puedo trabajar con lo que me contás. Lo que no me digas lo tengo que adivinar — y cuando adivino, me equivoco.",
    ],
  },
  m2: {
    id: "m2",
    boton: "VER POR DÓNDE EMPIEZO",
    parrafos: [
      "El número que te voy a mostrar a continuación, es el tiempo que estás perdiendo por no tener esto automatizado, y lo que te cuesta en plata.",
      "No está para que te sientas mal.",
      "Está para mostrarte algo simple: hay una parte de tu semana que no necesita tu cabeza. Cargar datos, copiar de un lado a otro, mandar el mismo mensaje cuarenta veces. Eso se lo dejás a la IA.",
      "Pero lo importante no es lo que sacás. [[Es lo que queda en su lugar.]]",
      "Las horas que hoy se te van en ejecutar son justo las que te faltan para pensar. Y con horas de pensar se hacen las cosas que nadie tiene tiempo de hacer: cosas del tipo ver de dónde puede venir más trabajo, entender por qué un problema se repite, o encontrar dónde se está yendo la plata.",
      "Ninguna de esas es urgente. Todas cambian el resultado.",
      "De eso se trata lo que sigue. No es trabajar menos. Es que tu tiempo esté puesto donde rinde de verdad, y [[donde a vos te entusiasma estar.]]",
    ],
  },
  m3: {
    id: "m3",
    boton: "VAMOS",
    parrafos: [
      "Lo que viene ahora es la parte que casi todos quieren saltear.",
      "Escribir cómo se hace hoy, paso por paso. Suena a trámite.",
      "Pero es exactamente lo que separa una automatización que anda de una que devuelve cualquier cosa: si el proceso vive solo en tu cabeza, la IA tiene que adivinar esa parte. Y adivina mal.",
      "[[Son diez minutos que te ahorran horas todos los meses.]]",
      "Y te queda escrito para siempre, uses IA o no.",
    ],
  },
  m4: {
    id: "m4",
    boton: "MOSTRAME",
    parrafos: [
      "{Nombre}, esto es [[el cerebro de {Empresa}]].",
      "Lo armamos nosotros con todo lo que nos contaste: cómo trabajan, quién hace qué, dónde se va el tiempo, con qué herramientas. Escrito en primera persona, como si lo dijeras vos.",
      "Y acá está lo que lo hace valer: la IA no se acuerda de nada. Cada vez que abrís una conversación arranca de cero y le tenés que explicar todo otra vez.",
      "Con esto, no. Le pegás el cerebro y ya sabe.",
      "Además crece. Cada proceso que definimos juntos entra acá y lo hace más útil. En unos meses este documento va a saber más de {Empresa} que cualquier persona que entre a trabajar mañana.",
      "[[Es la última vez que tenés que explicar todo desde cero.]]",
      "Ahora vamos a dejarlo instalado en tu herramienta. Son cuatro pasos y quedan hechos para siempre.",
    ],
  },
  m5: {
    id: "m5",
    boton: "SEGUIR",
    parrafos: [
      "Acabás de hacer algo que en la mayoría de los lugares no se hace nunca.",
      "No es que ahorraste {horas} horas por mes. Es que [[ahora sabés cómo se hace.]]",
      "El segundo proceso te va a llevar la mitad de tiempo. El tercero, menos.",
      "Y el día que se te ocurra algo nuevo, ya no vas a preguntarte si se puede. Vas a saber cómo.",
    ],
  },
  m6: {
    id: "m6",
    boton: "LO ANOTO",
    input: true,
    inputPlaceholder: "La que más te cambiaría el año…",
    parrafos: [
      "{Nombre}, pará un segundo.",
      "Cuando arrancamos te dije que lo importante no era el tiempo que ibas a sacarte de encima, sino lo que ibas a poner en su lugar.",
      "Bueno: ya tenés [[{horas} horas por mes]]. Son {dias} días de trabajo que antes no existían.",
      "Y acá viene la parte incómoda. Ese tiempo no se convierte solo en algo que valga la pena. Si no decidís en qué lo vas a usar, en dos semanas se llena de más de lo mismo — otras tareas, otros pendientes — y vas a terminar igual de ocupado, haciendo cosas distintas.",
      "[[Nadie planifica el tiempo que gana. Por eso lo pierde.]]",
      "Así que antes de seguir quiero que lo escribas. Una cosa sola: la que más te cambiaría el año si por fin tuvieras tiempo de hacerla.",
      "¿En qué vas a usar esas horas?",
    ],
  },
  m7: {
    id: "m7",
    boton: "ENTENDIDO, VAMOS",
    video: "empleado_nuevo",
    parrafos: [
      "{Nombre}, antes de pegarlo, una idea que cambia todo.",
      "Lo que vas a pegar no es un programa que se instala y listo. Es un empleado nuevo en su primer día.",
      "Sabe muchísimo, pero no sabe cómo se hace en {Empresa}. La primera vez se va a equivocar en algo. Es normal: a una persona nueva también la corregís.",
      "[[La diferencia es que este aprende en el acto.]] Le decís «eso no va así, hacelo de esta forma», y a la vuelta siguiente sale bien.",
      "Por eso hoy no lo dejamos solo. Lo mirás trabajar, lo corregís en el mismo chat, y probás otra vez. Dos o tres vueltas y queda.",
      "Y no termina hoy: cada semana lo vas puliendo un poco más. Como a cualquiera que trabaja con vos.",
    ],
  },
};

export function interpolar(txt, vars = {}) {
  return String(txt)
    .replace(/\{Nombre\}/g, vars.nombre || "")
    .replace(/\{Empresa\}/g, vars.empresa || "acá adentro")
    .replace(/\{horas\}/g, vars.horas != null ? vars.horas : "")
    .replace(/\{dias\}/g, vars.dias != null ? vars.dias : "");
}
